import Navbar from "../components/Navbar";
import AnimatedBg from "../components/AnimatedBg";

export default function MainLayout({ children }) {
  return (
    <div className="min-h-screen relative text-gray-900 overflow-x-hidden">

      {/* 🌿 Background (lowest) */}
      <div className="fixed inset-0 -z-20">
        <AnimatedBg />
      </div>

      {/* 🌫 Overlay */}
      <div className="fixed inset-0 bg-white/30 backdrop-blur-[3px] -z-10" />

      {/* 🌿 Navbar (top) */}
      <div className="relative z-50">
        <Navbar />
      </div>

      {/* 📄 Content */}
      <main className="relative z-10 pt-28 px-4 md:px-10 lg:px-20">
        {children}
      </main>

      {/* 🌿 Footer */}
      <footer className="relative z-10 text-center py-6 text-green-900">
        © {new Date().getFullYear()} Vandevrai Foundation 🌿
      </footer>
    </div>
  );
}